import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  IconButton,
  TextField,
  Chip,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Dialog,
  Slide,
  Stack, Tooltip
} from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import ShareRoundedIcon from "@mui/icons-material/ShareRounded";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import axios from "../../../utils/fvAxios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditTraningMoodle from "./EditTraningMoodle";
import EmployeeCerdentials from "./EmployeeCerdentials";
import fileDownload from "js-file-download";
import Nodata from "../../Nodata/Nodata";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import Mastercard from "../../../icons/Dot.svg"
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { useTranslation } from "react-i18next";
import DialogTitle from "@mui/material/DialogTitle";
import EmpBlackIcon from "../../../icons/BlackList";
import EmpBlackedIcon from "../../../icons/BlackListed";
import InfoIcon from '@mui/icons-material/Info';
import GetfVDateFormate from "../../../utils/Genaricfunctions";
import { getOrgType } from "../../../utils/Token";
import BlacklistedNew from "../../../icons/BlackListedNew.svg";


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#667085",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

export default function EmployeeSearch({ row, openTabs, EmpBlackPOP, BlackLInfo, ClientListInfo, DeTag }) {

  // vendorid
  // fvuserid
  const [GetSpecificEmployee, setGetSpecificEmployee] = React.useState([]);
  const [error, setError] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [spinner, setSpinner] = React.useState(false);
  const SpinnerClose = () => {
    setSpinner(false);
  };
  const date = new Date();
  const formattedDate = date.toLocaleDateString("en-US", {
    month: "2-digit", // 2-digit representation of the month
    day: "2-digit",   // 2-digit representation of the day
    year: "numeric",  // 4-digit representation of the year
  });


  useEffect(() => {
    if (openTabs) {
      setSpinner(true)
    }
    axios
      .post(
        "Employee/GetSpecificEmployeeQuizzes?VendorId=" + row?.vendorid + "&EmployeeUserId=" + row?.fvuserid
      )

      .then((res) => {

        if (res?.data) {
          setGetSpecificEmployee(res?.data?.data);
          setSpinner(false)

        } else {
          setError(res?.data?.responseMessage);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [refresh]);

  const DeleteEmployee = async () => {
    axios
      .post(
        "Employee/DeleteMoodleUserCourse?userId=" + Emp + "&courseId=" + EmpId,
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      .then((res) => {
        if (res?.data?.responseMessage == "Success") {
          toast.success(res?.data?.data, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setRefresh(!refresh)
        } else {
          toast.error(res?.data?.data, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }

      })
      .catch((err) => {
        console.log(err);
      });
  };
  const [openpop, setOpenpop] = React.useState(false);
  const [EmpId, setEmpId] = React.useState();
  const [Emp, setEmp] = React.useState();

  const { t } = useTranslation();
  const handleClickOpenpop = (user, id) => {
    setEmp(user)
    setEmpId(id)
    setOpenpop(true);
  };

  const handlePopClose = () => {
    setOpenpop(false);
  };
  const [open1, setOpen1] = React.useState(false);
  const [users, setUser] = React.useState();
  const [courses, setCourse] = React.useState();
  const [moodles, setMoodle] = React.useState();
  const [CertificateDownload, setCertificateDownloade] = React.useState();
  const handleClickOpen = (user, cousre, moodle) => {
    setUser(user);
    setCourse(cousre);
    setMoodle(moodle);
    setOpen1(true);
  };

  const handleClose = () => {
    setOpen1(false);
  };
  const [emailopen, seEmailtOpen1] = React.useState(false);
  const [emaildata, seEmailtdata] = React.useState(false);

  const handleClickEmail = (e) => {

    seEmailtdata(e);
    seEmailtOpen1(true);
  };
  const handleEmailClose1 = () => {
    seEmailtOpen1(false);
  };


  const handleDownload = (id, ids, num) => {

    setSpinner(true);
    const exp = num == '0' ? ids?.expiringdatetodisplay : ids?.expiringdate;
    const last = num == '0' ? ids?.lastwatchedtodisplay : ids?.lastwatched;
    axios
      .get(
        "Employee/GenerateTrainingCompletionCertificateForMoodleCourse?userId=" +
        id +
        "&courseId=" +
        ids?.courseid +
        "&courseName=" +
        ids?.coursename +
        "&lastWatched=" +
        last +
        "&previouslyPassedOn=" +
        ids?.previouslypassed +
        "&quizStatus=" +
        ids?.quizstatus +
        "&renewalstatus=" +
        ids?.isrenewal +
        "&expiringdate=" +
        exp,
        {
          responseType: "blob",
        }
      )
      .then((res) => {
        // fileDownload(res.data, "Training Certificate.pdf");
        const blob = new Blob([res?.data], { type: res?.headers['content-type'] });
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
        URL.revokeObjectURL(blobUrl);
        setSpinner(false);
      });
  };
  const handleDownload1 = (Trainid, fvuser, lastwatch) => {
    setSpinner(true);
    axios
      .get(
        "Documents/DownloadTrainingDoc?fileName=" +
        Trainid +
        "&empId=" +
        fvuser +
        "&empDate=" +
        lastwatch,
        {
          responseType: "blob",
        }
      )
      .then((res) => {
        // fileDownload(res.data, "Download Document.pdf");
        const blob = new Blob([res?.data], { type: res?.headers['content-type'] });
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
        URL.revokeObjectURL(blobUrl);
        setSpinner(false);
      });
  };

  const GenerateQuizWaiverFormCertificate = (quizId, isMoodleCourse, courseId, userId, submittedDate, quizDetailsId) => {
    setSpinner(true);
    axios
      .get(
        isMoodleCourse
          ? "Employee/GenerateQuizWaiverFormCertificateForMoodleCourse?userId=" +
          userId +
          "&courseId=" +
          courseId +
          "&submittedDate=" +
          submittedDate +
          "&quizdetailsId=" +
          quizDetailsId
          : "Employee/GenerateQuizWaiverFormCertificate?sysUserOrgQuizId=" +
          quizId,
        {
          responseType: "blob",
        }
      )
      .then((res) => {
        // fileDownload(res.data, "Waiver Form.pdf");
        const blob = new Blob([res?.data], { type: res?.headers['content-type'] });
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
        URL.revokeObjectURL(blobUrl);
        setSpinner(false);
      });
  };

  return (
    <>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={spinner}
        onClick={SpinnerClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ToastContainer />

      <Dialog
        open={openpop}
        keepMounted
        onClose={handlePopClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle> {"Are you sure you want to delete the employee training?"}</DialogTitle>
        <DialogContent>
          {/* <DialogContentText id="alert-dialog-slide-description">
            {t('VendorDetails.label9')}
          </DialogContentText> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handlePopClose}>{"Cancel"}</Button>
          <Button onClick={DeleteEmployee}>{t('VendorDetails.label8')}</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullScreen
        open={emailopen}
        onClose={handleEmailClose1}
        TransitionComponent={Transition}
      >
        <EmployeeCerdentials handleClose1={handleEmailClose1} emailData={emaildata} />
      </Dialog>
      <Dialog
        open={open1}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <EditTraningMoodle
          close={handleClose}
          users={users}
          courses={courses}
          moodles={moodles}
        />
      </Dialog>

      <Box sx={{ margin: 1, paddingLeft: "60px" }}>

        <Table aria-label="getspecific">
          {GetSpecificEmployee == undefined ? ("") : (<>
            {GetSpecificEmployee?.map((item, i) => (
              <React.Fragment key={i}>
                <TableHead >
                  <Stack direction="row" spacing={2}>
                    <span style={{ padding: "10px" }}>
                      <h4 style={{ color: "#667085", fontWeight: "600" }}>{item[0]?.clientname}</h4></span>  <span style={{ padding: "10px" }}>  <Chip
                        sx={{ color: "#344054", fontWeight: "bold", }}
                        label={
                          <span>
                            {Array.from(new Set(item?.map((r) => r?.quizstatus)))
                              ?.length >= 2
                              ? (
                                <div>
                                  <svg viewBox="0 0 24 24" width="20" height="20">
                                    <circle cx="12" cy="12" r="10" fill="white" />
                                    <path d="M12 12 L12 2 A10 10 0 0 1 22 12 Z" fill="#ED8A17" />
                                    <path d="M12 12 L22 12 A10 10 0 0 1 12 22 Z" fill="#12B76A" />
                                    <path d="M12 12 L12 22 A10 10 0 0 1 2 12 Z" fill="#5925DC" />
                                    <path d="M12 12 L2 12 A10 10 0 0 1 12 2 Z" fill="#EE3F3F" />
                                  </svg>
                                  <span style={{ marginLeft: "2px" }}>Multiple</span>
                                </div>
                              )
                              : (
                                //         <span><FiberManualRecordIcon sx={{marginRight:"5px",color:Array.from(new Set(item?.map((r) => r?.quizstatus)))=="Passed"? "#12B76A":""||
                                //     "Not Attended"?"#ED8A17" :""||
                                //     "Failed"?"#ED8A17":""||
                                //     "In Process"? "#5925DC":""}}/>{Array.from(new Set(item?.map((r) => r?.quizstatus)))}</span>)
                                //     }{" "}
                                // </span>
                                <span><FiberManualRecordIcon hidden={Array.from(new Set(item?.map((r) => r?.quizstatus))) != "Passed"} sx={{ color: "#12B76A" }} /> <FiberManualRecordIcon hidden={Array.from(new Set(item?.map((r) => r?.quizstatus))) != "Not Attended"} sx={{ color: "#ED8A17" }} /> <FiberManualRecordIcon hidden={Array.from(new Set(item?.map((r) => r?.quizstatus))) != "Failed"} sx={{ color: "#EE3F3F" }} /> <FiberManualRecordIcon hidden={Array.from(new Set(item?.map((r) => r?.quizstatus))) != "InProcess"} sx={{ color: "#5925DC" }} />   <img src={Mastercard} alt="Expired" style={{ width: "20px", marginRight: "5px" }} hidden={Array.from(new Set(item?.map((r) => r?.quizstatus))) != "Expired"} />  {Array.from(new Set(item?.map((r) => r?.quizstatus)))}  </span>)
                            }{""}
                          </span>
                        }
                      />
                    </span>
                    <div hidden={DeTag == 1 || getOrgType() == "Vendor" || getOrgType() == "Client"}>
                      <div style={{ padding: "10px", float: "right", marginTop: "8px" }} hidden={BlackLInfo?.find((r) => r?.moodleEmpId == row?.userid)?.isGloballyBlackListed == true}>
                        {(() => {
                          const emp = BlackLInfo?.find((r) => r?.moodleEmpId == row?.userid);
                          const clientId = ClientListInfo?.find((r) => r?.text == item[0]?.clientname)?.value;

                          if (emp?.isGloballyBlackListed) return null;

                          if (!emp) {
                            return (
                              <Box
                                sx={{ position: "relative", width: 30, height: 30, cursor: "pointer" }}
                                onClick={() => EmpBlackPOP(3, row?.fvuserid, row?.userid, item[0]?.clientname)}
                              >
                                <EmpBlackIcon />
                              </Box>
                            );
                          }
                          const siteNames = emp.blacklistedLocationsInfo
                            ?.filter((loc) => loc?.clientId == clientId)
                            ?.map((r) => r?.siteName)
                            ?.join(", ");
                          const TillDate = emp?.blacklistedLocationsInfo
                            ?.find(item => item.clientId == clientId)?.blackListedTill

                          if (!siteNames) {
                            return (
                              <Box
                                sx={{ position: "relative", width: 30, height: 30, cursor: "pointer" }}
                                onClick={() => EmpBlackPOP(3, row?.fvuserid, row?.userid, item[0]?.clientname)}
                              >
                                <EmpBlackIcon />
                              </Box>
                            );
                          }

                          return (
                            <div style={{ display: "flex", alignItems: "center", float: "right", cursor: "pointer" }}>
                              <Box
                                sx={{ position: "relative", width: 30, height: 30, cursor: "pointer", mr: 1 }}
                                onClick={() => EmpBlackPOP(4, row?.fvuserid, row?.userid, item[0]?.clientname)}
                              >
                                <EmpBlackedIcon />
                              </Box>

                              <Tooltip title={siteNames} placement="top" arrow>
                                {/* <InfoIcon sx={{ fontSize: 35, color: "#b9baba", cursor: "pointer" }} /> */}
                                <img src={BlacklistedNew} alt="Blacklisted" width="30" height="30" />
                              </Tooltip>

                              <Box sx={{ position: "relative", mr: 3 }}>
                                <span className="mx-2" style={{ color: "#3E4A62", fontSize: "18px" }}>{GetfVDateFormate(TillDate)}</span>
                              </Box>
                            </div>
                          );
                        })()}

                      </div>
                    </div>
                  </Stack>
                  <TableRow>

                    <StyledTableCell align="left">Course Name</StyledTableCell>
                    <StyledTableCell align="left">Status</StyledTableCell>
                    <StyledTableCell align="left">Last Watched</StyledTableCell>
                    <StyledTableCell align="left">
                      Expiration Date
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      Previously Passed
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      Is it a renewal
                    </StyledTableCell>
                    <StyledTableCell align="left">&nbsp;</StyledTableCell>
                    <StyledTableCell align="left">&nbsp;</StyledTableCell>
                    <StyledTableCell align="left">&nbsp;</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>

                  {item?.map((r, index) => (
                    <React.Fragment>
                      <TableRow key={index}>
                        <TableCell component="th" scope="row">
                          {r?.coursename}
                        </TableCell>
                        <TableCell align={r?.quizstatus ? "left" : "center"}>
                          <Chip
                            sx={{ color: "#344054", fontWeight: "bold", }}
                            label={
                              <span>


                                <span><FiberManualRecordIcon hidden={r?.quizstatus != "Passed"} sx={{ color: "#12B76A" }} /> <FiberManualRecordIcon hidden={r?.quizstatus != "Not Attended"} sx={{ color: "#ED8A17" }} /> <FiberManualRecordIcon hidden={r?.quizstatus != "Failed"} sx={{ color: "#EE3F3F" }} /> <FiberManualRecordIcon hidden={r?.quizstatus != "InProcess"} sx={{ color: "#5925DC" }} />   <img src={Mastercard} alt="Expired" style={{ width: "20px", marginRight: "5px" }} hidden={r?.quizstatus != "Expired"} />        {r?.quizstatus}</span>

                              </span>
                            }
                          />
                        </TableCell>
                        <TableCell align={r?.lastwatched ? "left" : "center"}>
                          {r?.lastwatched}
                        </TableCell>
                        <TableCell align={r?.expiringdate ? "left" : "center"}>
                          {r.expiringdate ? r.expiringdate : "-"}
                        </TableCell>
                        <TableCell align={r?.previouslypassed ? "left" : "center"}>
                          {r?.previouslypassed ? r?.previouslypassedstatus + "-" + r?.previouslypassed : "-"}
                        </TableCell>
                        <TableCell align={"center"}>
                          {r?.isrenewal == true ? "Yes" : "No"}

                        </TableCell>
                        <TableCell style={{ width: "20px" }}>
                          <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() => {
                              handleClickEmail(
                                row?.fvuserid
                              );
                            }}
                          >
                            <Tooltip title="Share User Credentials" placement="top" arrow>
                              <ShareRoundedIcon sx={{ color: "#98A2B3" }} /></Tooltip>
                          </IconButton>
                        </TableCell>
                        <TableCell style={{ width: "20px" }}>
                          <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() => {
                              handleClickOpen(
                                row?.userid,
                                r?.courseid,
                                r?.isMoodleCourse
                              );
                            }}
                          >
                            <Tooltip title="Edit Employee Training Category" placement="top" arrow>
                              <EditRoundedIcon sx={{ color: "#98A2B3" }} /></Tooltip>
                          </IconButton>
                        </TableCell>
                        <TableCell style={{ width: "20px" }}>
                          <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() => handleClickOpenpop(row?.userid, r?.courseid)}
                          >
                            <Tooltip title="Delete" placement="top" arrow>
                              <DeleteOutlineIcon sx={{ color: "#98A2B3" }} /></Tooltip>
                          </IconButton>
                        </TableCell>
                      </TableRow>
                      <TableCell colSpan={3}>
                        <Box
                          sx={{

                            padding: "10px",

                          }}
                        >
                          <div

                            style={{ display: ((r?.hasTrainingCertificate === true || r?.previousQuizNotExpired === true) && r?.clientHasTrainingCertificate === true ? "" : "none") }}
                          >
                            <Button
                              onClick={() =>
                                handleDownload(
                                  row?.userid,
                                  r, "0"

                                )
                              }
                              style={{
                                color: "#2A93DB",
                                cursor: "pointer",

                              }}
                            >
                              <InsertDriveFileOutlinedIcon
                                sx={{
                                  marginRight: "5px",
                                  color: "#2A93DB",
                                  cursor: "pointer",
                                }}
                              />
                              Training Certificate
                            </Button>
                            {r?.hasRenewalTrainingCertificate === true &&
                              r?.oldquizexpiringdate != null &&
                              (r?.oldquizexpiringdate) > formattedDate ? (
                              <Button
                                onClick={() =>
                                  handleDownload(
                                    row?.userid,
                                    r, "1"

                                  )
                                }
                                style={{
                                  color: "#2A93DB",
                                  cursor: "pointer",

                                }}
                              >
                                <InsertDriveFileOutlinedIcon
                                  sx={{
                                    marginRight: "5px",
                                    color: "#2A93DB",
                                    cursor: "pointer",
                                  }}
                                />
                                Renewal Training Certificate

                              </Button>


                            ) : (
                              <></>
                            )}
                          </div>
                          {((r?.HasTrainingCertificate === true || r?.PreviousQuizNotExpired === true) &&
                            r?.ClientHasTrainingCertificate === true) && (
                              <tr>

                                <td colSpan={3}>
                                  <a
                                    onClick={() =>
                                      handleDownload(
                                        row?.userid,
                                        r

                                      )
                                    }
                                    href="javascript:void(0)"
                                  >
                                    <i
                                      className="fa fa-file-pdf-o"
                                      style={{
                                        fontSize: 'x-large',
                                        paddingRight: '10px',
                                        color: 'red',
                                      }}
                                    ></i>
                                    Training Certificate
                                  </a>
                                </td>
                                {r?.HasRenewalTrainingCertificate === true &&
                                  r?.PreviousQuizNotExpired != null &&
                                  (r?.PreviousQuizNotExpired) > formattedDate ? (
                                  <td colSpan={4}>
                                    <a
                                      onClick={() =>
                                        handleDownload(
                                          row?.userid,
                                          r

                                        )
                                      }
                                      href="javascript:void(0)"
                                    >
                                      <i
                                        className="fa fa-file-pdf-o"
                                        style={{
                                          fontSize: 'x-large',
                                          paddingRight: '10px',
                                          color: 'red',
                                        }}
                                      ></i>
                                      Renewal Training Certificate
                                    </a>
                                  </td>
                                ) : (
                                  <td colSpan={4}>hi</td>
                                )}
                              </tr>
                            )}



                          {r?.waiverFormConfigured === true && r?.quizstatus === "Passed" && (
                            r?.quizWaiverFormDocuments?.map((doc, index) => (
                              <Button
                                key={index}
                                onClick={() =>
                                  GenerateQuizWaiverFormCertificate(
                                    r?.sysUserOrgQuizId,
                                    r?.isMoodleCourse,
                                    r?.courseId,
                                    r?.lastWatchedOrSubmitted,
                                    doc?.id
                                  )
                                }
                                sx={{ color: "#2A93DB" }}
                              >
                                <InsertDriveFileOutlinedIcon
                                  sx={{ marginRight: "5px", color: "#2A93DB" }}
                                />
                                {doc?.displayName ? doc?.displayName : "Additional Form"}
                              </Button>
                            ))
                          )}



                          {r?.waiverFormConfigured === true && r?.quizstatus === "Passed" && (
                            r?.quizWaiverFormDocuments?.map((doc, index) => (
                              <Button
                                key={index}
                                onClick={() =>
                                  GenerateQuizWaiverFormCertificate(
                                    r?.sysUserOrgQuizId,
                                    r?.isMoodleCourse,
                                    r?.courseId,
                                    r?.lastWatchedOrSubmitted,
                                    doc?.id
                                  )
                                }
                                sx={{ color: "#2A93DB" }}
                              >
                                <InsertDriveFileOutlinedIcon
                                  sx={{ marginRight: "5px", color: "#2A93DB" }}
                                />
                                {doc?.displayName ? doc?.displayName : "Additional Form"}
                              </Button>
                            ))
                          )}

                          {(r?.PreviousQuizNotExpired === true || r?.quizstatus === "Passed") &&
                            r?.waiverFormConfigured === true &&
                            r?.quizWaiverFormDocuments?.map((doc, index) => (
                              <Button
                                key={index}
                                onClick={() =>
                                  GenerateQuizWaiverFormCertificate(
                                    r?.clientcode,
                                    true,
                                    r?.courseId,
                                    row?.fvuserid,
                                    r?.lastwatched,
                                    doc?.id
                                  )
                                }
                                sx={{ color: "#2A93DB" }}
                              >
                                <InsertDriveFileOutlinedIcon
                                  sx={{ marginRight: "5px", color: "#2A93DB" }}
                                />
                                {doc?.displayName ? doc?.displayName : "Additional Form"}
                              </Button>
                            ))}

                          {(
                            (r?.trainingDocumentConfigured === true &&
                              r?.quizstatus === "Passed") ||
                            (r?.previousQuizNotExpired && r?.trainingDocumentId !== "")
                          ) &&
                            r?.quizDocuments?.map((quizDoc, quizIndex) => (
                              <Button
                                key={quizIndex}
                                onClick={() =>
                                  handleDownload1(
                                    quizDoc?.documentId,
                                    row?.fvuserid,
                                    r?.lastwatched
                                  )
                                }
                                sx={{ color: "#2A93DB" }}
                              >
                                <InsertDriveFileOutlinedIcon
                                  sx={{ marginRight: "5px", color: "#2A93DB" }}
                                />
                                {quizDoc?.displayName
                                  ? quizDoc?.displayName
                                  : "Download Document"}
                              </Button>
                            ))}
                        </Box>
                      </TableCell>
                    </React.Fragment>
                  ))}
                </TableBody>
              </React.Fragment>
            ))} </>)}

          <div
            style={{ display: GetSpecificEmployee?.length > 0 || spinner ? "none" : "" }}
          >
            {" "}
            <Nodata />
          </div>
          {/* </TableBody> */}
        </Table>
      </Box>
      {/* </Delayed> */}
    </>
  );
}
